module.exports = __webpack_public_path__ + "assets/img/discernment_car_scene1.8df87d89.png";